import { render } from "./SubscribePage.vue?vue&type=template&id=1a2067f1"
import script from "./SubscribePage.vue?vue&type=script&lang=js"
export * from "./SubscribePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__